import { createSlice } from "@reduxjs/toolkit";

const initialGameCancelModalSlice = { isOpen: false, data: {} }

const gameCancelModalSlice = createSlice({
    name: 'game_cancel_modal',
    initialState: initialGameCancelModalSlice,
    reducers: {
        openModal(state, action) {
            state.isOpen = true
            state.data = action.payload || {};
        },
        closeModal(state) {
            state.isOpen = false
        }
    }
})

export const gameCancelModalActions = gameCancelModalSlice.actions;
export default gameCancelModalSlice